import { render, staticRenderFns } from "./PlatformKeysPier.vue?vue&type=template&id=60cc7279&"
import script from "./PlatformKeysPier.vue?vue&type=script&lang=js&"
export * from "./PlatformKeysPier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports